import React from "react";
import { Link } from "react-router-dom";

import lithiumbanner from "../img/services/lithium/lithium-banner.jpg";
import wheeler3wheelerbatteries from "../img/services/lithium/2wheeler-3wheeler-batteries.jpg";
import lithiumbatterymanufacturing from "../img/services/lithium/lithium-battery-manufacturing.jpg";
import lithiumbatteryproduct1 from "../img/services/lithium/lithium-battery-product1.jpg";
import lithiumbatteryproduct2 from "../img/services/lithium/lithium-battery-product2.jpg";
import lithiumbatteryproduct3 from "../img/services/lithium/lithium-battery-product3.jpg";
import lithiumbatteryproduct4 from "../img/services/lithium/lithium-battery-product4.jpg";
import lithiumbatteryproduct5 from "../img/services/lithium/lithium-battery-product5.jpg";
import lithiumbatteryproduct6 from "../img/services/lithium/lithium-battery-product6.jpg";
import lithiumbatteryproduct7 from "../img/services/lithium/lithium-battery-product7.jpg";
import lithiumbatteryproduct8 from "../img/services/lithium/lithium-battery-product8.jpg";
import lithiumbatteryproduct9 from "../img/services/lithium/lithium-battery-product9.jpg";
import lithiumbatteryproduct10 from "../img/services/lithium/lithium-battery-product10.jpg";
import lithiumbattery from "../img/services/lithium/lithium-banner.jpg";

import lithiumVideo from "../video/lithiumvideo.mp4";

import  LithiumCatalogue from '../catalogues/lithium/Lithium-battery-16-pages-V1.pdf';
import LithiumIonBattery from '../catalogues/final-V1.pdf';
import Bessandess from '../catalogues/(V3).pdf';

import Lithiumbatteryvideo from "../video/1730806203537.mp4";

function Lithiumbattery() {
  return (
    <div className="page-content">
      <div className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center video-background">
        <video autoPlay loop muted playsInline className="background-video desk">
          <source src={lithiumVideo} type="video/mp4" autoPlay/>
          Your browser does not support the video tag.
        </video>

        <div className="video-overlay"></div>
      </div>
      {/* INNER PAGE BANNER END */}
      {/* SECTION CONTENT START */}
      <div className="section-full p-t80 p-b50 mobile-page-padding">
        <div className="container">
          {/* GALLERY CONTENT START */}
          <div className="row">
            <div className="col-lg-4 col-md-12 sticky_column">
              <div className="about4-section m-b20 bg-gray p-a20">
                {/*
                <div className="widget widget_services">
                  <h4 className="widget-title">Our Business Verticals</h4>
                  <ul className="bg-white">
                    <li>
                      <Link to="/our-services/led-lights">Led Lights</Link>
                    </li>
                    <li>
                      <Link to="/our-services/inverter-ups">Inverter &amp; UPS</Link>
                    </li>
                    <li>
                      <Link to="/our-services/sheet-metal">CNC Lazer Cut Machines</Link>
                    </li>
                  </ul>
                </div>*/}
                <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                  <a
                    href={LithiumCatalogue}
                    className="btn-block"
                    target="_blank"
                  >
                    <span className="text-black m-r10">
                      <i className="fa fa-file-pdf-o" />
                    </span>
                    <strong className="text-uppercase text-black">
                      Lithium Catalogue 
                    </strong>
                  </a>
                </div>
                <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                  <a
                    href={LithiumIonBattery}
                    className="btn-block"
                    target="_blank"
                  >
                    <span className="text-black m-r10">
                      <i className="fa fa-file-pdf-o" />
                    </span>
                    <strong className="text-uppercase text-black">
                      Lithium-Ion BATTERIES
                    </strong>
                  </a>
                </div>
                <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                  <a
                    href={Bessandess}
                    className="btn-block"
                    target="_blank"
                  >
                    <span className="text-black m-r10">
                      <i className="fa fa-file-pdf-o" />
                    </span>
                    <strong className="text-uppercase text-black">
                      CUSTOMISED ESS / BESS Solutions
                    </strong>
                  </a>
                </div>

                {/*
                <div className="about4-content m-t30">
                  <h4>GET SPECIAL OFFER</h4>
                  <p>Contact us Now and Get Special offer on your Projects</p>
                  <a
                    href="https://wa.link/jb4lfe"
                    className="site-button-link"
                    target="_blank"
                  >
                    Chat with us!
                  </a>
                </div>*/}
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="section-content">
                <div className="service-single-block m-b30">
                  {/* <div class="sx-media">
                              	<img src="/img/services/lithium/lithium-battery-manufacturing.jpg" alt="">
                              </div> */}
                  <h3 className="m-t30 sx-tilte">
                    Powering 2W &amp; 3W Mobility with Advanced Telecom
                    Batteries
                  </h3>
                  <div className="sx-media">
                    <img src={wheeler3wheelerbatteries} alt="" />
                  </div>
                  <p>
                    In the realm of sustainable transportation solutions, the
                    shift towards electric vehicles (EVs) marks a pivotal
                    moment. At the forefront of this revolution stands Finike
                    Lithium, a pioneering manufacturer based near Chandigarh,
                    specializing in lithium batteries tailored for 2-wheelers,
                    3-wheelers, Telecom, ESS, UPS, Data Center and Inverter .
                    Let's delve into how Finike Lithium is shaping the future of
                    mobility with its innovative battery solutions.
                  </p>
                  <h4 className="m-t30 sx-tilte">
                    Advantages of Choosing Finike Lithium Batteries:
                  </h4>
                  <div className="single-service-list">
                    <div className="row">
                      <div className="col-lg-6 col-md-12">
                        <ul className="list-angle-right anchor-line">
                          <li>Enhanced Performance and Efficiency</li>
                          <li>Cost-Effectiveness</li>
                        </ul>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <ul className="list-angle-right anchor-line">
                          <li>Eco-Friendly Solution</li>
                          <li>Advanced Technology Integration</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="sx-media sx-img-effect zoom-slow">
                    <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                      <img src={lithiumbattery} alt="" />
                      <a
                        href={Lithiumbatteryvideo}
                        className="mfp-video play-now"
                         target='_blank'
                      >
                        <i className="icon fa fa-play" />
                        <span className="ripple" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="sx-accordion acc-bg-gray m-b30" id="accordion5">
                  <div className="panel sx-panel">
                    <div className="acod-head acc-actives">
                      <h6 className="acod-title">
                        <a
                          data-toggle="collapse"
                          href="#collapseOne5"
                          data-parent="#accordion5"
                        >
                          Why choose lithium batteries for electric vehicles?
                          <span className="indicator">
                            <i className="fa" />
                          </span>
                        </a>
                      </h6>
                    </div>
                    <div id="collapseOne5" className="acod-body collapse show">
                      <div className="acod-content p-tb15">
                        <p>
                          Lithium batteries offer high energy density, longer
                          range, and faster charging.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="panel sx-panel">
                    <div className="acod-head">
                      <h6 className="acod-title">
                        <a
                          data-toggle="collapse"
                          href="#collapseTwo5"
                          className="collapsed"
                          data-parent="#accordion5"
                        >
                          How do lithium batteries benefit the environment?
                          <span className="indicator">
                            <i className="fa" />
                          </span>
                        </a>
                      </h6>
                    </div>
                    <div id="collapseTwo5" className="acod-body collapse">
                      <div className="acod-content p-tb15">
                        They reduce emissions, promote cleaner air, and are
                        recyclable.
                      </div>
                    </div>
                  </div>
                  <div className="panel sx-panel">
                    <div className="acod-head">
                      <h6 className="acod-title">
                        <a
                          data-toggle="collapse"
                          href="#collapseThree5"
                          className="collapsed"
                          data-parent="#accordion5"
                        >
                          What advantages do lithium batteries offer in
                          performance?
                          <span className="indicator">
                            <i className="fa" />
                          </span>
                        </a>
                      </h6>
                    </div>
                    <div id="collapseThree5" className="acod-body collapse">
                      <div className="acod-content p-tb15">
                        They provide efficient power delivery, low maintenance,
                        and cost-effectiveness.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* GALLERY CONTENT END */}
        </div>
        {/* Similar projects START */}

        {/* Similar projects END */}
      </div>
    </div>
  );
}

export default Lithiumbattery;
